module.exports = __webpack_public_path__ + "img/eac.8c229ac0.svg";